const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const toApiDate = (value) => {
    if (!value) {
        return '';
    }

    const [year, month, day] = value.split('-');

    if (!year || !month || !day) {
        return '';
    }

    return `${day}-${month}-${year}`;
};

export const getLeadAnalyticsApi = async ({ fromDate = '', toDate = '', leadId = null, managerId = null, deskId = null, managerIds = [], deskIds = [] } = {}) => {
    const token = localStorage.getItem('token');

    if (!token) {
        throw new Error('Token not found');
    }

    const params = new URLSearchParams();

    const normalizedFromDate = toApiDate(fromDate);
    const normalizedToDate = toApiDate(toDate);

    if (normalizedFromDate) {
        params.append('from_date', normalizedFromDate);
    }

    if (normalizedToDate) {
        params.append('to_date', normalizedToDate);
    }

    if (leadId) {
        params.append('lead_id', String(leadId));
    }

    const normalizedManagerIds = Array.isArray(managerIds) ? managerIds.filter(Boolean) : [];
    const normalizedDeskIds = Array.isArray(deskIds) ? deskIds.filter(Boolean) : [];

    if (normalizedManagerIds.length > 0) {
        normalizedManagerIds.forEach((value) => params.append('manager_ids[]', String(value)));
    } else if (managerId) {
        params.append('manager_id', String(managerId));
    }

    if (normalizedDeskIds.length > 0) {
        normalizedDeskIds.forEach((value) => params.append('desk_ids[]', String(value)));
    } else if (deskId) {
        params.append('desk_id', String(deskId));
    }

    const query = params.toString();
    const url = `${API_BASE_URL}/admin/lead/analytics${query ? `?${query}` : ''}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw { ...errorData, statusCode: response.status };
    }

    return response.json();
};
